import moment from "moment";
import store from "@/store/";

export default {
  nextWorkingDay() {
    let today = moment(new Date());
    return today.day() < 5 ? moment(today.add(1, 'days')).format('DD/MM/YYYY') : moment(today.add(7, 'days').day(1)).format('DD/MM/YYYY');
  },
}


// WEBPACK FOOTER //
// ./src/mixins/dateSetters.js